// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.traffic-container{
    width:110px;
    background:#222;
    border-radius:25px;
    padding:20px;
    display:flex;
    flex-direction:column;
    gap:20px;
    align-items:center;
}


.light{
    width:60px;
    height:60px;
    border-radius:50%;
    background:#555;
}


.red{
    background:red;
}


.yellow{
    background:yellow;
}


.green{
    background:green;
}


.blink{
    animation:blink-animation 1s infinite;
}


@keyframes blink-animation{

    0%{
        opacity:1;
    }

    50%{
        opacity:0.2;
    }

    100%{
        opacity:1;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/TrafficLight/TrafficLight.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,cAAc;AAClB;;;AAGA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;;AAGA;IACI,qCAAqC;AACzC;;;AAGA;;IAEI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;AAEJ","sourcesContent":[".traffic-container{\r\n    width:110px;\r\n    background:#222;\r\n    border-radius:25px;\r\n    padding:20px;\r\n    display:flex;\r\n    flex-direction:column;\r\n    gap:20px;\r\n    align-items:center;\r\n}\r\n\r\n\r\n.light{\r\n    width:60px;\r\n    height:60px;\r\n    border-radius:50%;\r\n    background:#555;\r\n}\r\n\r\n\r\n.red{\r\n    background:red;\r\n}\r\n\r\n\r\n.yellow{\r\n    background:yellow;\r\n}\r\n\r\n\r\n.green{\r\n    background:green;\r\n}\r\n\r\n\r\n.blink{\r\n    animation:blink-animation 1s infinite;\r\n}\r\n\r\n\r\n@keyframes blink-animation{\r\n\r\n    0%{\r\n        opacity:1;\r\n    }\r\n\r\n    50%{\r\n        opacity:0.2;\r\n    }\r\n\r\n    100%{\r\n        opacity:1;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
